import { call, put } from 'redux-saga/effects'
// @ts-ignore
import req from '@sportninja/common/api/request'
import actions from '../actions/account'
// @ts-ignore
import { generateSagas } from './utils'

export const api = {
  read: async (id: string) => await req(`/account/${id}`),
}

const accountSagas = [
  [
    actions.read,
    function* ({ id }: { id: string }) {
      const response = yield call(api.read, id)
      yield put(actions.read.success({ data: response.data }))
      return response
    },
  ],
]

export default generateSagas([...accountSagas])
